$(document).ready(function(){

    var winW = $(window).width();

	 $('#main-photo ul').slick({
	  slidesToShow: 1,
	  slidesToScroll: 1,
	  arrows: false,
	  fade: true,
	  asNavFor: '#mini-photos ul'
	});
	$('#mini-photos ul').slick({
	  slidesToShow: 4,
	  slidesToScroll: 1,
      vertical: false,
	  asNavFor: '#main-photo ul',
	  dots: false,
	  arrows: false,
	  centerMode: false,
	  focusOnSelect: true,
      responsive: [
        {
          breakpoint: 830,
          settings: {
            vertical: false,
          }
        }
      ]
	});


	// Header

  var barraH = $('.barra').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function(){
    var barraH = $('.barra').outerHeight();
    var headerH = $('header').outerHeight();
  });

  $('body').css('padding-top', barraH + headerH);

  $('header').css('top', barraH);

  $(window).scroll(function(){
    if ($(window).scrollTop() > barraH) {
      $('header').addClass('fix');
      $('header').css('top', 0);
    } else {
      $('header').removeClass('fix');
      $('header').css('top', barraH);
    }
  });

	$('header .icons li .search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

    $('header .big-search .cerrar-big-search').click(function(){
		$('header .big-search').toggleClass('show');
        $('header .black-search').toggleClass('show');
	});

	$('header .icons li .cart').click(function(){
		$('#minicart').addClass('show');
	});
	$('#minicart .cerrar').click(function(){
		$('#minicart').removeClass('show');
	});

	$('header .show-menu').click(function(){
		$('nav').addClass('show');
	});
	$('header nav .cerrar').click(function(){
		$('nav').removeClass('show');
	});

  	// Product

    $('.product .deon > h3').each(function(){
      $(this).addClass('accor');
      $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
    })

    $('.product .deon h3').click(function(){
      $(this).toggleClass('active');
      $(this).next('.hide-info').toggleClass('show');
    });

  $('.featured-collection ul .item[data-id="4833619345540"]').remove();
  $('.featured-collection ul .item[data-id="4833617182852"]').remove();

    // Pop Up

    $('#popup .cerrar').click(function(){
      $('#popup').removeClass('show');
    });

    // Carrito

    $('.carrito .term .check').click(function() {
      var clicks = $(this).data('clicks');
      if (clicks) {
        $(this).removeClass('clicked');
        $('.carrito .botones .not').fadeIn(200);
        $('.carrito .term').addClass('alert');
      } else {
        $(this).addClass('clicked');
        $('.carrito .botones .not').fadeOut(200);
        $('.carrito .term').removeClass('alert');
      }
      $(this).data("clicks", !clicks);
    });

    $('.carrito .botones .not').click(function(){
      $('.carrito .term').addClass('alert');
    });



    if ( winW < 830 ) {
      //$('nav ul.menu > li.site-nav--has-dropdown > a').removeAttr('href');

      $('nav ul.menu > li.site-nav--has-dropdown > a').each(function(){
        var href = $(this).attr('href');
        console.log('href: ' + href);

        $(this).click(function(e){
        	e.preventDefault();
            $(this).click(function(){
				//window.location.href = href;
            });
        });

      });

      $('nav ul.menu > li.site-nav--has-dropdown').click(function(){
        $(this).siblings().children('.sub-menu').removeClass('show');
        $(this).children('.sub-menu').toggleClass('show');
      });
    }

});
